
import Vue from "vue";
import { Component } from "vue-property-decorator";
declare var NODE_ENV:string //вебпак заменит на нужное значение при сборке

@Component
export default class AppComponent extends Vue {  
  constructor() {
    super();

  }
  errorCaptured(error: any) {
    this.$notification.error(error);
    if (error && typeof error === "object" && (error.ErrorMessage !== undefined || error.IsSuccess !== undefined)) {
      return false;
    }
  }
  get isDevelopment(): boolean{
    return NODE_ENV==='development';
  }  
  created(){
           
  }

}
